import * as React from "react";
import PropTypes from "prop-types";
import cs from "classnames";
import { getFlattedContextData } from "../utils";
import BraQuizDataContext from "../utils/quizDataContext";

import styles from "./quiz-pagination.module.scss";

const QuizPagination = ({
  isVisible,
  questionNumber,
  autofocus,
  isAbsolutePosition,
  isEmbedded,
}) => {
  const paginationRef = React.useRef();
  const braQuizData = React.useContext(BraQuizDataContext);
  const { questions, paginationText } = getFlattedContextData(braQuizData);
  const totalQuestions = questions.length;

  React.useEffect(() => {
    if (isVisible && autofocus) {
      paginationRef.current?.focus();
    }
  }, [paginationRef, isVisible, autofocus, questionNumber]);

  const questionIndex = `${questionNumber} ${paginationText} ${totalQuestions}`;

  return (
    <div
      className={cs(styles.quizPagination, {
        [styles.quizPaginationActive]: isVisible,
        [styles.quizPaginationAbsolutePosition]:
          isAbsolutePosition && !isEmbedded,
        "lll-text-center": !isEmbedded,
      })}
      data-testid="quiz-pagination"
    >
      <span
        className={cs(styles.quizPaginationGroup, {
          "lll-text-body-3": isEmbedded,
          "lll-text-body-2": !isEmbedded,
        })}
        tabIndex="-1"
        ref={paginationRef}
      >
        <span className="lll-hidden-visually">{"Step " + questionIndex}</span>
        <span aria-hidden="true">{questionIndex}</span>
      </span>
    </div>
  );
};

QuizPagination.defaultProps = {
  autofocus: false,
  isAbsolutePosition: false,
  isEmbedded: false,
  isVisible: true,
};

QuizPagination.propTypes = {
  autofocus: PropTypes.bool,
  isAbsolutePosition: PropTypes.bool,
  isEmbedded: PropTypes.bool,
  isVisible: PropTypes.bool,
  questionNumber: PropTypes.number.isRequired,
};

export default QuizPagination;
